/**
 * vite magic : https://vite.dev/guide/features.html#glob-import
 * output becomes:
 * {
 *  '../../../images/icons/design-system/matas/16px/bell.svg': svgComponent,
 *  '../../../images/icons/design-system/matas/16px/basket.svg': svgComponent,
 *  etc...
 * }
 */

const icons = import.meta.env.PROD
    ? import.meta.glob<{ default: (props: Record<string, unknown>) => React.ReactSVGElement }>(
          // If production build we exclude base icons
          ['../../../images/icons/design-system/**', '!../../../images/icons/design-system/base'],
          {
              eager: true,
              query: '?react'
          }
      )
    : import.meta.glob<{ default: (props: Record<string, unknown>) => React.ReactSVGElement }>(
          ['../../../images/icons/design-system/**'],
          {
              eager: true,
              query: '?react'
          }
      );

export default icons;
